import { render, staticRenderFns } from "./A7ClassificacaoIndicadorFilterItem.vue?vue&type=template&id=152856d4&scoped=true&"
import script from "./A7ClassificacaoIndicadorFilterItem.vue?vue&type=script&lang=js&"
export * from "./A7ClassificacaoIndicadorFilterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152856d4",
  null
  
)

export default component.exports